import axios from "../../utils/axios";

export const getVideos = async (tags, search, author, start, limit) => {
  let queryString = "";

  if (tags?.length > 0) {
    queryString += tags.map((tag) => `tags_like=${tag}`).join("&");
  }

  if (search !== "") {
    queryString += `&q=${search}`;
  }
  if (author) {
    queryString += `&author=${author}`;
  }

  if (limit) {
    queryString += `&_limit=${limit}`;
  }

  queryString += `&_start=${start}`;

  const response = await axios.get(`/videos/?${queryString}`);

  return response;
};
